import { LIBRARY_PREVIEW_FULL_REPORT_SETTINGS_LABEL } from "../../utils/libraryPreviewFullReport";

export default function VendorPreviewFullReportSetting({
  className,
  checked,
  disabled,
  onToggle,
}) {
  return (
    <div className="sm:col-span-2">
      <dd>
        <label className={className}>
          <div className="flex h-6 shrink-0 items-center">
            <div className="group grid size-4 grid-cols-1">
              <input
                id="org-setting-preview-full-report"
                type="checkbox"
                checked={!!checked}
                readOnly={disabled}
                onChange={() => !disabled && onToggle?.()}
                className="col-start-1 row-start-1 size-4 appearance-none rounded-sm border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              />
              <svg
                viewBox="0 0 16 16"
                fill="white"
                className="pointer-events-none col-start-1 row-start-1 size-4 opacity-0 group-has-[input:checked]:opacity-100"
                aria-hidden
              >
                <path d="M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z" />
              </svg>
            </div>
          </div>
          <span className="text-sm/6 font-medium text-gray-900">
            {LIBRARY_PREVIEW_FULL_REPORT_SETTINGS_LABEL}
          </span>
        </label>
      </dd>
    </div>
  );
}
